// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ed63fe17","453":"88c6ff54","732":"8ae582a4","977":"30a590c8"}[chunkId] + ".chunk.js";
};